import styles from '../components/ClaimCardMainInformation/ClaimCardMainInformation.module.css'
import { ClaimStatus } from '../components/ClaimCardMainInformation/ClaimCardMainInformation'

export const createRuStatusValueForClaim = (value: string): ClaimStatus => {
  switch (value) {
    case 'inProgress':
      return 'В работе'
    case 'accepted':
      return 'Завершена'
    case 'rejected':
      return 'Отменена'
    case 'confirmed':
      return 'Потверждён'
    case 'inAnticipation':
      return 'Предварительная бронь'
    case 'canceled':
      return 'Отклонена'
    case 'unconfirmed':
      return 'Не подтверждена'
    default:
      return 'В работе'
  }
}

export const createEnStatusValueForClaim = (value: string) => {
  switch (value) {
    case 'В работе':
      return 'inProgress'
    case 'Завершена':
      return 'accepted'
    case 'Отменена':
      return 'rejected'
    case 'Потверждён':
      return 'confirmed'
    case 'Предварительная бронь':
      return 'inAnticipation'
    case 'Отклонена':
      return 'canceled'
    case 'Не подтверждена':
      return 'unconfirmed'
    default:
      return 'inProgress'
  }
}

export const createStyleForStatusClaim = (value: string) => {
  switch (value) {
    case 'inProgress':
      return styles.statusInProgress
    case 'accepted':
      return styles.statusPositive
    case 'rejected':
      return styles.statusNegative
    case 'confirmed':
      return styles.statusConfirmed
    case 'inAnticipation':
      return styles.statusInAnticipation
    case 'canceled':
      return styles.statusCanceled
    case 'unconfirmed':
      return styles.statusNegative
    default:
      return styles.statusInProgress
  }
}

export const createStyleForRegistatironRequest = (value: string) => {
  switch (value) {
    case 'inProgress':
      return styles.statusInProgressRegistrationRequest
    case 'accepted':
      return styles.statusPositiveRegistrationRequest
    case 'rejected':
      return styles.statusNegativeRegistrationRequest
    default:
      return styles.statusInProgressRegistrationRequest
  }
}

export const createStyleForStatusTable = (value: string) => {
  switch (value) {
    case 'inProgress':
      return 'rgba(228, 183, 255, 1)'
    case 'accepted':
      return 'rgba(238, 238, 238, 1)'
    case 'rejected':
      return 'rgba(252, 216, 212, 1)'
    case 'confirmed':
      return 'rgba(154, 202, 60, 1)'
    case 'inAnticipation':
      return 'rgba(255, 243, 224, 1)'
    case 'canceled':
      return 'rgba(227, 227, 227, 1)'
    default:
      return 'white'
  }
}
